<template>
  <div></div>
</template>

<script>
export default {
  name: 'Verify',
  created() {
    this.$store.dispatch('aweber/verifyAccount');
  },
};
</script>



// WEBPACK FOOTER //
// Verify.vue?10ceca63